export type LogParameterValue = string | number | boolean | undefined | null;

export type LogParameterObject = Record<string, LogParameterValue>;

export type LogParameters = Record<
  string,
  | LogParameterValue
  | string[]
  | LogParameterObject
  | LogParameterObject[]
>;

export type ID = string;

type EventMethod = (
  title: string,
  action: string,
  parameters?: LogParameters,
  options?: { useKlaviyo?: boolean },
) => Promise<void> | null;

type SpecificEventMethod = (
  title: string,
  parameters?: LogParameters,
  options?: { useKlaviyo?: boolean },
) => Promise<void> | null;

type ViewEventMethod = (parameters?: LogParameters, options?: { useKlaviyo?: boolean }) => Promise<void> | null;

// TODO: Migrate Logger interface to dispatchGTMEvent() - see useLogger.ts for refactoring details
export interface Logger {
  click: SpecificEventMethod;
  confirmed: SpecificEventMethod;
  created: SpecificEventMethod;
  updated: SpecificEventMethod;
  selected: SpecificEventMethod;
  filled: SpecificEventMethod;
  impressed: SpecificEventMethod;
  unimpressed: SpecificEventMethod;
  searched: SpecificEventMethod;
  view: ViewEventMethod;
  event: EventMethod;
  isInitialized: boolean;
}

export type EventLogger = (props: { event?: string; params?: LogParameters }) => void;
